export default __webpack_public_path__ + "static/media/planet-2.36423f17.png";